"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ComponentIconButtonPage"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconButtonPage/index.ts
// module id = 677
// module chunks = 0